<template>
    <v-autocomplete v-model="$data._subject" :items="subjects" :item-text="itemText" item-value="_id" v-bind="$attrs" />
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        _subject: null,
        subjects: [],
    }),
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        "$data._subject"(_subject) {
            this.$emit("input", _subject);
        },
    },
    methods: {
        sync() {
            this.$data._subject = this.value;
        },
        async init() {
            this.subjects = (await api.console.rental.subjects.gets())?.subjects || [];
        },
        itemText({ name }) {
            return `${name}`;
        },
    },
};
</script>

<style></style>
